"use client";

import React, { useState } from "react";
import { Image, Video, AudioWaveform, Wand, Settings2, Download, Sparkles, Cpu, Clock } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const aiTools = [{
  id: "image",
  label: "Home Loans",
  icon: Image,
  previewImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637844/img/ai_generated_cyberpunk_city.png",
  readouts: {
    res: "LVR 95%",
    model: "Expert Choice",
    time: "48h Approval",
    status: "AVAILABLE"
  },
  placeholder: "Discuss your home loan needs...",
  defaultPrompt: "Smarter mortgage solutions designed for your future. Whether you are a first home buyer, looking to refinance, or investing, we secure the most competitive rates from 30+ leading lenders across Australia.",
  settings: ["Low Deposit Options", "Refinance Savings", "Investment Strategy"]
}, {
  id: "video",
  label: "Business Loans",
  icon: Video,
  previewImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637844/img/ai_generated_nebula_timelapse.png",
  readouts: {
    res: "Limit $10M+",
    model: "Growth Capital",
    time: "24h Review",
    status: "AVAILABLE"
  },
  placeholder: "Tell us about your business goals...",
  defaultPrompt: "Empower your business growth with flexible commercial finance. From working capital to expansion funding, we find the right structure to support your long-term success and operational efficiency.",
  settings: ["Working Capital", "Equipment Finance", "Commercial Property"]
}, {
  id: "audio",
  label: "Car / Equipment loans",
  icon: AudioWaveform,
  previewImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637844/img/ai_generated_audio_waveform.png",
  readouts: {
    res: "Terms 1-7y",
    model: "Fleet & Tools",
    time: "Instant Quote",
    status: "AVAILABLE"
  },
  placeholder: "Describe the assets you need...",
  defaultPrompt: "Secure the equipment and vehicles your business needs today. Our tailored asset finance solutions help preserve your cash flow while providing the necessary tools for operational excellence.",
  settings: ["Vehicle Leasing", "Heavy Machinery", "Medical Equipment"]
}];
export default function GenerativeAiSuite() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [activeTab, setActiveTab] = useState(aiTools[0].id);
  const [isGenerating, setIsGenerating] = useState(false);
  const handleGenerate = () => {
    setIsGenerating(true);
    setTimeout(() => setIsGenerating(false), 2000);
  };
  return;
}